module.exports = __webpack_public_path__ + "media/images/icon__profile-6ec1e82423771e3fd9f3b31ffdc82014.png";